import React, { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

/** Floating back-to-top button, appears after scrolling past 600px. */
export default function BackToTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="Back to top"
      data-testid="back-to-top"
      className="fixed bottom-6 right-6 z-40 w-11 h-11 rounded-full border border-white/30 bg-black/50 backdrop-blur-md flex items-center justify-center text-white/80 hover:text-white hover:border-white/80"
      style={{
        opacity: show ? 1 : 0,
        pointerEvents: show ? "auto" : "none",
        transition: "opacity 0.35s ease, border-color 0.25s ease, color 0.25s ease",
      }}
    >
      <ArrowUp size={18} strokeWidth={1.5} />
    </button>
  );
}
